// import {stores} from "../stores";

// export function replacePlaceholders(s: string): string {
//     let r = s;
//     let p = s.indexOf('%CHANNEL_A%');
//     //FIXME: factorize this code
//     if (p) {
//         let v = 1 + stores.memory.getGlobalParamValue("CHAN_OFFSET");
//         r = r.replaceAll('%CHANNEL_A%', v.toString(10))
//     }
//     p = s.indexOf('%CHANNEL_B%');
//     if (p) {
//         let v = 2 + stores.memory.getGlobalParamValue("CHAN_OFFSET");
//         r = r.replaceAll('%CHANNEL_B%', v.toString(10))
//     }
//     p = s.indexOf('%CHANNEL_C%');
//     if (p) {
//         let v = 3 + stores.memory.getGlobalParamValue("CHAN_OFFSET");
//         r = r.replaceAll('%CHANNEL_C%', v.toString(10))
//     }
//     p = s.indexOf('%CHANNEL_D%');
//     if (p) {
//         let v = 4 + stores.memory.getGlobalParamValue("CHAN_OFFSET");
//         r = r.replaceAll('%CHANNEL_D%', v.toString(10))
//     }
//     return r;
// }

export function replacePlaceholders(s: string): string {
    const defaultOffset = 0; // Default channel offset
    const channelMap: { [key: string]: number } = {
        'A': 1,
        'B': 2,
        'C': 3,
        'D': 4
    };

    return s.replace(/%CHANNEL_([ABCD])%/g, (match, letter: string) => {
        const channelNumber = channelMap[letter as keyof typeof channelMap] + defaultOffset;
        return channelNumber.toString(10);
    });
}